import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
export default class PhoneNumbersCustomInput extends Component {
    constructor(props) {
        super(props);
        this.onChange = (e) => {
            this.setState({ value: e.target.value });
            this.props.telephonyGetQueryNumbers({
                query: {
                    search: e.target.value,
                },
            });
        };
        this.state = {
            value: '',
        };
    }
    render() {
        return (_jsx("li", Object.assign({ className: "phone-number-field-holder" }, { children: _jsx("div", Object.assign({ className: "form-group nolabel" }, { children: _jsx("div", Object.assign({ className: "input-group" }, { children: _jsx("input", { type: "text", placeholder: "Type a number to filter...", onChange: this.onChange, value: this.state.value, className: "form-control" }) })) })) })));
    }
}
